import * as React from 'react'
import CustomListActions from '../../../components/CustomListActions'
import CouponsListFiltersArray from './Filters'

const CouponsListActions = () => {
  return (
    <CustomListActions
      filtersAvailable={CouponsListFiltersArray.map((item) => ({
        label: item.label,
        value: item.value,
      }))}
      hasCreate
    />
  )
}

export default CouponsListActions
